import React, { FC } from 'react';
import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { Flex, NakedButton, Icon } from '@qga/roo-ui/components';
import { DateRangeRenderProps } from '../../types';

export const CalendarNav: FC<DateRangeRenderProps> = ({ calendars, getBackProps, getForwardProps }) => (
  <Wrapper>
    <Button aria-label="Previous month" {...getBackProps({ calendars })}>
      <Icon name="chevronLeft" />
    </Button>

    <Button aria-label="Next month" {...getForwardProps({ calendars })}>
      <Icon name="chevronRight" />
    </Button>
  </Wrapper>
);

const Wrapper = styled(Flex)`
  position: absolute;
  left: ${themeGet('space.10')};
  right: ${themeGet('space.10')};
  justify-content: space-between;
  padding: 0 ${themeGet('space.4')};
`;

const Button = styled(NakedButton)`
  border-radius: ${themeGet('radii.rounded')};
  background: ${themeGet('colors.white')};
  color: ${themeGet('colors.greys.steel')};
  box-shadow: ${themeGet('shadows.default')};

  &:hover,
  &:focus {
    outline: none;
    color: ${themeGet('colors.brand.primary')};
  }

  &:disabled {
    cursor: not-allowed;
    box-shadow: none;
    color: ${themeGet('colors.greys.alto')};
  }
`;
